export default {
	title:"lanmeiweb",
	baseUrl:{
		dev:"/api",
		prod:"/api"
	}
}